import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField, NumberField } from '../../atoms';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Row, Col, Button, Spin, notification } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormActions } from '../../components';
import { FORM_CLASSIFIERS_SELLER_EDIT } from '../../constants/formKeys';
import {
  getClassifiersSellerChange,
  getClassifiersSellerItem,
  getClassifiersSellerItemData,
} from '../../reducers/classifiersReducer';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { seller } from '../../constants/parameters';
import validateSchema from './validateSchema';
import classifiersStore from '../../utils/classifiersStore';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

export class ParameterSellerEdit extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    fetchClassifierSeller: PropTypes.func.isRequired,
    changeClassifierSeller: PropTypes.func.isRequired,
    fetchClassifierSellerList: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    ownCode: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
  };

  componentDidMount = () => {
    const { ownCode } = this.props;

    if (ownCode) {
      this.props.fetchClassifierSeller(ownCode);
    }
  };

  onSubmit = async (values) => {
    const { t, changeClassifierSeller, fetchClassifierSellerList, onComplete } =
      this.props;

    await changeClassifierSeller(values);

    notification.info({
      message: t('completeTitle'),
      description: t('completeBody'),
    });

    onComplete();
    await fetchClassifierSellerList();
    await classifiersStore.update();
  };

  render() {
    const { t, isLoading, ownCode, onCancel, initialValues } = this.props;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_CLASSIFIERS_SELLER_EDIT} />
              <Row gutter={32}>
                <Col span={24}>
                  <Field
                    name={seller.CODE}
                    label={t('fieldSellerCode')}
                    component={TextField}
                    disabled={!!ownCode}
                    required
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={seller.NAME}
                    label={t('fieldSellerName')}
                    component={TextField}
                    required
                  />
                </Col>
                <Col span={12}>
                  <Field
                    className="date-field"
                    name={seller.SOLD}
                    label={t('fieldSellerSold')}
                    component={NumberField}
                    precision={0}
                    min={1}
                    max={1000000000}
                    required
                  />
                </Col>
              </Row>
              <FormActions>
                <Button onClick={onCancel}>{t('buttonCancel')}</Button>
                <Button htmlType="submit" type="primary">
                  {t('buttonSave')}
                </Button>
              </FormActions>
            </form>
          )}
        />
      </Spin>
    );
  }
}

const getIsLoading = getLoadingSelector(
  getClassifiersSellerChange,
  getClassifiersSellerItem
);

const mapStateToProps = (state, ownProps) => ({
  initialValues: ownProps.ownCode
    ? getClassifiersSellerItemData(state)?.toJS()
    : {},
  isLoading: getIsLoading(state),
});

const mapDispatchToProps = {
  fetchClassifierSeller: actions.fetchClassifierSeller,
  changeClassifierSeller: actions.changeClassifierSeller,
  fetchClassifierSellerList: actions.fetchClassifierSellerList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParameterSellerEdit);
